var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homeRoot"}},[_c('div',{attrs:{"id":"homeGrid"}},[_c('router-link',{attrs:{"id":"featuredCard","to":'/feature/' + 0}},[_c('FeaturedCard')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }